<div class="row">
  <div (click)="toggleShowMe()" class="d-flex flex-grow justify-content-between no-select cursor-pointer">
    <h3 class="zero-text p-base-med">Benachrichtigungen</h3>
    <web-design-system-icon name="chevron" [class.icon-rotate]="!showMe" />
  </div>
</div>

<div class="row opacity-container" [class.active]="showMe">
  <div class="col-12 mt-3">
    <div class="row mb-3">
      <div class="px-0 col-12 mb-4" [zeroLoadingIndicator]="ongoingRequest">
        <h4 class="mb-2 zero-text p-small-bold">E-Mail Benachrichtigungen zu Orders</h4>
        <web-design-system-switch
          label="Erhalte eine E-Mail Benachrichtigung bei Ausführung von Limitorders oder bei Ablauf der Gültigkeit einer Order."
          [checked]="emailOrdersNotification"
          (checkedChange)="changeEmailNotification('emailnotification_orders', $event)"
        />
      </div>
      <div class="px-0 col-12" [zeroLoadingIndicator]="ongoingRequest">
        <h4 class="mb-2 zero-text p-small-bold">E-Mail Benachrichtigungen zu Geldeingängen</h4>
        <web-design-system-switch
          label="Erhalte eine E-Mail Benachrichtigung bei Geldeingängen durch Überweisungen, Dividenden, Steuerausgleich oder sonstige Gutschriften."
          [checked]="emailMoneyNotification"
          (checkedChange)="changeEmailNotification('emailnotification_money', $event)"
        />
      </div>
    </div>
    <alerting-clever-push-subscriptions />
    @if (resultMessage) {
      <div class="row">
        <p class="zero-text course-green" [class.course-red]="resultError">{{ resultMessage }}</p>
      </div>
    }
  </div>
</div>
